"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleDashboardStoreAccessor = void 0;
var DashboardStoreAccessorRepository_1 = require("./DashboardStoreAccessorRepository");
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * This `mocked` ID is used as a key under which is the accessor object stored in the instance of the
 * {@link DashboardStoreAccessorRepository}.
 */
var DASHBOARD = sdk_model_1.serializeObjRef(sdk_model_1.idRef("SingleDashboardStoreAccessor_mock_dashboard_id"));
/**
 * This singleton class uses {@link DashboardStoreAccessorRepository} to create a store accessor for
 * a single dashboard.
 *
 * @remarks
 * The usage of this singleton is the same as for {@link DashboardStoreAccessorRepository} except functions
 * don't accept any parameters.
 *
 * @public
 */
var SingleDashboardStoreAccessor = /** @class */ (function () {
    function SingleDashboardStoreAccessor() {
    }
    /**
     * Returns a selector for current dashboard.
     */
    SingleDashboardStoreAccessor.getDashboardSelect = function () {
        return DashboardStoreAccessorRepository_1.DashboardStoreAccessorRepository.getAccessorsForDashboard(DASHBOARD).getDashboardSelect();
    };
    /**
     * Returns a dispatch object for current dashboard.
     */
    SingleDashboardStoreAccessor.getDashboardDispatch = function () {
        return DashboardStoreAccessorRepository_1.DashboardStoreAccessorRepository.getAccessorsForDashboard(DASHBOARD).getDashboardDispatch();
    };
    /**
     * Creates a {@link Dashboard#onStateChange} callback for current dashboard.
     */
    SingleDashboardStoreAccessor.getOnChangeHandler = function () {
        return DashboardStoreAccessorRepository_1.DashboardStoreAccessorRepository.getOnChangeHandlerForDashboard(DASHBOARD);
    };
    /**
     * Removes dashboard accessors from {@link DashboardStoreAccessorRepository#accessors} for current dashboard.
     */
    SingleDashboardStoreAccessor.clearAccessor = function () {
        DashboardStoreAccessorRepository_1.DashboardStoreAccessorRepository.clearAccessorForDashboard(DASHBOARD);
    };
    /**
     * Checks if accessors is initialized for current dashboard.
     */
    SingleDashboardStoreAccessor.isAccessorInitialized = function () {
        return DashboardStoreAccessorRepository_1.DashboardStoreAccessorRepository.isAccessorInitializedForDashboard(DASHBOARD);
    };
    return SingleDashboardStoreAccessor;
}());
exports.SingleDashboardStoreAccessor = SingleDashboardStoreAccessor;
//# sourceMappingURL=SingleDashboardStoreAccessor.js.map